import script from "./HowToReturnGR.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToReturnGR.vue?vue&type=script&setup=true&lang=js"

import "./HowToReturnGR.vue?vue&type=style&index=0&id=39669f91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39669f91"]])

export default __exports__